import { useQuery } from '@tanstack/react-query';

import { api } from './api';

/**
 * A depreciação de UMA máquina (0096), para a ficha: a lista inteira vem numa
 * consulta só, a mesma chave da tela de custos — gravar numa invalida a outra.
 */
export function useDepreciacaoDaMaquina(equipamentoId: string, habilitada: boolean) {
  const consulta = useQuery({ queryKey: ['custos', 'depreciacao'], queryFn: api.depreciacao, enabled: habilitada });
  return { consulta, maquina: consulta.data?.maquinas.find((m) => m.equipamentoId === equipamentoId) ?? null };
}
